import { render, staticRenderFns } from "./AddGoods.vue?vue&type=template&id=e25c4bea&scoped=true"
import script from "./AddGoods.vue?vue&type=script&lang=js"
export * from "./AddGoods.vue?vue&type=script&lang=js"
import style0 from "./AddGoods.vue?vue&type=style&index=0&id=e25c4bea&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e25c4bea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e25c4bea')) {
      api.createRecord('e25c4bea', component.options)
    } else {
      api.reload('e25c4bea', component.options)
    }
    module.hot.accept("./AddGoods.vue?vue&type=template&id=e25c4bea&scoped=true", function () {
      api.rerender('e25c4bea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/clientManage/distributor/dialogs/AddGoods.vue"
export default component.exports